import React from 'react'
import { ContainerSpinnerStyled } from './spinnerStyles'

const Spinner = () => {
  return (
    <ContainerSpinnerStyled></ContainerSpinnerStyled>
  )
}

export default Spinner